import React from 'react';
import styled, { keyframes } from 'styled-components';
import { Icon } from '@ifixit/toolbox';

const rotate360 = keyframes`
   from {
      transform: rotate(0deg);
   }

   to {
      transform: rotate(360deg);
   }
`;

const LoadingContainer = styled.div`
   width: ${props => props.size}px;
   height: ${props => props.size}px;
   text-align: center;
   animation: ${rotate360} 2s infinite linear;
`;

const LoadingIndicator = ({ size, ...props }) => (
   <LoadingContainer size={size} {...props}>
      <Icon name="loader" size={size} className="svg-icon" />
   </LoadingContainer>
);

export default LoadingIndicator;
